exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sortable_pick[data-v-19c9b65c]{cursor:pointer}.border-container[data-v-19c9b65c]{border:1px solid;border-color:#ccc!important;border-radius:.5rem;overflow:hidden}.icon-select[data-v-19c9b65c]{padding:8px}.table-full .v-datatable.v-table>tbody[data-v-19c9b65c]{max-height:calc(102vh - 426px);min-height:calc(102vh - 426px)}table.v-table>thead tr[data-v-19c9b65c]{background-color:#ddd;height:40px}[data-v-19c9b65c] .padded .v-input__slot{padding-left:8px!important}", ""]);

// exports
